import { render, staticRenderFns } from "./KTextArea.vue?vue&type=template&id=6093c3ab&scoped=true&"
import script from "./KTextArea.vue?vue&type=script&lang=js&"
export * from "./KTextArea.vue?vue&type=script&lang=js&"
import style0 from "./KTextArea.vue?vue&type=style&index=0&id=6093c3ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6093c3ab",
  null
  
)

export default component.exports